import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Col, Row } from 'react-bootstrap';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import { Images, Expand, Calendar, X } from 'lucide-react';

const config = require('../../config.json');

export default function PhotoGalleryHome(props) {
  const [galleryImages, setGalleryImages] = useState([]);
  const [collapsed, setCollapsed] = useState(true);
  const [selectedProject, setSelectedProject] = useState([]);
  const [selectedTitle, setSelectedTitle] = useState('');
  const [loaded, setLoaded] = useState(true);

  useEffect(() => {
    fetchGalleryImages();
  }, []);

  const fetchGalleryImages = async () => {
    try {
      setLoaded(false);
      const fileName = 'images/gallery/';
      const bucketName = 'images.vidyajyoticollege.in';

      const response = await axios.get(
        `${config.api.invokeURL}/gallery?fileName=${fileName}&bucketName=${bucketName}`,
        {
          headers: {
            'x-api-key': config.api.key
          }
        }
      );

      if (response.data) {
        if (props.task === 'Home') {
          const tempRes = response.data;
          tempRes.sort((a, b) => new Date(b.projectDate) - new Date(a.projectDate));
          const slicedArray = tempRes.slice(0, 9);
          setGalleryImages(slicedArray);
        } else {
          setGalleryImages(response.data);
        }
      }
    } catch (error) {
      console.error("Error fetching gallery:", error);
    } finally {
      setLoaded(true);
    }
  };

  const assignProject = (event, item) => {
    event.preventDefault();
    setSelectedProject(item.fileName || []);
    setSelectedTitle(item.projectName || 'Photo Gallery');
    setCollapsed(false);
  };

  const toggle = () => {
    setCollapsed(!collapsed);
  };

  return (
    <div className="vj-home-gallery">
      {/* Fullscreen Lightbox Modal */}
      <Modal fullscreen isOpen={!collapsed} toggle={toggle} className="vj-lightbox-modal">
        <ModalHeader
          toggle={toggle}
          close={
            <button className="btn btn-sm btn-dark rounded-circle p-2" onClick={toggle}>
              <X size={20} />
            </button>
          }
        >
          <span className="fw-bold fs-5 text-dark">{selectedTitle}</span>
        </ModalHeader>
        <ModalBody className="d-flex align-items-center justify-content-center bg-dark p-0">
          <Carousel
            stopOnHover={true}
            dynamicHeight={false}
            infiniteLoop={true}
            autoPlay={true}
            showThumbs={true}
            showArrows={true}
            showIndicators={true}
            showStatus={true}
            className="w-100 text-center"
          >
            {selectedProject.map((img1, index) => (
              <div key={index} style={{ maxHeight: '85vh' }}>
                <img
                  src={`${config.s3.ImageinvokeURL}${img1}`}
                  alt="Gallery Item"
                  style={{ maxHeight: '80vh', objectFit: 'contain' }}
                />
              </div>
            ))}
          </Carousel>
        </ModalBody>
      </Modal>

      {/* Gallery Cards Grid */}
      <Row className="g-3">
        {!loaded && [1, 2, 3, 4, 5, 6].map((sk) => (
          <Col sm={6} md={6} lg={4} key={`skel-${sk}`}>
            <div className="vj-modern-card h-100 rounded-3 overflow-hidden" style={{ minHeight: '230px', background: '#f8fafc' }}>
              <div style={{ height: '160px', background: 'linear-gradient(90deg, #f1f5f9 0%, #e2e8f0 50%, #f1f5f9 100%)' }} />
              <div className="p-3">
                <div style={{ height: '14px', background: '#e2e8f0', borderRadius: '4px', width: '80%' }} />
              </div>
            </div>
          </Col>
        ))}
        {loaded && galleryImages.map((item, index) => {
          const coverImg = item.fileName && item.fileName.length > 0 ? item.fileName[0] : '';
          const photoCount = item.fileName ? item.fileName.length : 0;

          return (
            <Col sm={6} md={6} lg={4} key={index}>
              <div
                className="vj-modern-card h-100 cursor-pointer overflow-hidden position-relative"
                onClick={(e) => assignProject(e, item)}
                style={{ borderRadius: '14px' }}
              >
                <div className="position-relative" style={{ height: '170px', overflow: 'hidden' }}>
                  {coverImg ? (
                    <img
                      src={encodeURI(`${config.s3.ImageinvokeURL}${coverImg}`)}
                      alt={item.projectName}
                      className="w-100 h-100 object-fit-cover transition-zoom"
                      loading="lazy"
                    />
                  ) : (
                    <div className="w-100 h-100 d-flex align-items-center justify-content-center bg-light">
                      <Images size={28} className="text-muted" />
                    </div>
                  )}

                  {/* Photo count badge */}
                  <div
                    className="position-absolute bottom-0 end-0 m-2 px-2 py-1 rounded-pill small fw-bold text-white d-flex align-items-center gap-1"
                    style={{ background: 'rgba(15, 28, 63, 0.75)', backdropFilter: 'blur(4px)', fontSize: '0.75rem' }}
                  >
                    <Images size={12} /> {photoCount} Photos
                  </div>

                  <div className="vj-card-media-overlay" />
                </div>

                <div className="p-3 d-flex flex-column justify-content-between flex-grow-1">
                  <h6 className="fw-bold text-dark mb-1 line-clamp-2" style={{ fontSize: '0.92rem' }}>
                    {item.projectName}
                  </h6>
                  <div className="d-flex align-items-center justify-content-between text-muted small mt-2 pt-2 border-top">
                    <span className="d-flex align-items-center gap-1" style={{ fontSize: '0.78rem' }}>
                      <Calendar size={12} /> {item.projectDate || 'Recent'}
                    </span>
                    <span className="text-gold fw-semibold" style={{ fontSize: '0.78rem' }}>
                      View Album <Expand size={11} className="ms-1 inline-block" />
                    </span>
                  </div>
                </div>
              </div>
            </Col>
          );
        })}
      </Row>
    </div>
  );
}
